import { buildHtml, ContentRoute, RouteSlotInput } from '@caritas/ui';

export function mapConvertFlowBlock(
  input: BlockConvertFlowFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'rawHtml'> {
  return {
    key: 'rawHtml',
    input: () => [
      {
        Html: buildHtml(`<div class="${input.convertFlowId}"></div>`),
      },
      200,
    ],
  };
}
